import { HttpMethod, initFetch } from "../../utils/fetcher";

export const SAVE_SUCCESS_LOTS_NOTES = "SAVE_SUCCESS_LOTS_NOTES";
export const SAVE_FAIL_LOTS_NOTES = "SAVE_FAIL_LOTS_NOTES";
export const UPDATE_SUCCESS_LOTS_NOTES = "UPDATE_SUCCESS_LOTS_NOTES";
export const UPDATE_FAIL_LOTS_NOTES = "UPDATE_FAIL_LOTS_NOTES";
export const DELETE_SUCCESS_LOTS_NOTES = "DELETE_SUCCESS_LOTS_NOTES";
export const DELETE_FAIL_LOTS_NOTES = "DELETE_FAIL_LOTS_NOTES";

export function saveLotNote(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`lotsNotes`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.lot_note);
          dispatch({
            type: SAVE_SUCCESS_LOTS_NOTES,
            payload: res.lot_note,
          });
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_LOTS_NOTES,
            error: err,
          });
        });
    });
  };
}

export function updateLotNote(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`lotsNotes/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.lot_note);
          dispatch({
            type: UPDATE_SUCCESS_LOTS_NOTES,
            payload: res.lot_note,
            id: id,
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_LOTS_NOTES,
            error: err,
          })
        );
    });
  };
}

export function deleteLotNote(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`lotsNotes/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.lot_note);
          dispatch({
            type: DELETE_SUCCESS_LOTS_NOTES,
            payload: res.lot_note,
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_LOTS_NOTES,
            error: err,
          });
        });
    });
  };
}
